<script>
import Vue from 'vue';
import {mapState, mapActions, mapGetters} from 'vuex';

export default Vue.extend({
    computed: {
        ...mapState({
            part: state => state.contract.contractManagement.form.part,
            item: state => state.contract.contractManagement.item
        }),
        ...mapGetters({
            contractManagementProgressObject: 'contract/contractManagementProgressObject',
            emailSent: 'contract/emailSent'
        })
    },
    methods: {
        ...mapActions({
            contractManagementSendEmailBackOffice: 'contract/contractManagementSendEmailBackOffice',
            contractManagementSendEmailReview: 'contract/contractManagementSendEmailReview',
            sendReadyForReviewEmail: 'contract/sendReadyForReviewEmail'
        })
    }
});
</script>
<template>
    <div class="contract-management-edit-email">
        <transition-group name="fade" mode="out-in">
            <div v-if="contractManagementProgressObject.basic && contractManagementProgressObject.extended" :key="'readyForBackOffice'" class="contract-management-edit-email__content">
                <div class="contract-management-edit-email__left">{{ $t('contractManagement.edit.form.complete.contract') }}</div>
                <div class="contract-management-edit-email__right">
                    <span v-if="emailSent.readyForBackOffice">{{ $t('contractManagement.edit.form.emailSent') }}: {{ emailSent.readyForBackOffice | moment("DD/MM/Y\, HH:mm") }}</span>
                    <span v-if="!emailSent.readyForBackOffice"><button class="contract-management-edit-email__btn" @click="contractManagementSendEmailBackOffice">{{ $t('contractManagement.edit.form.email.backOffice') }}</button></span>
                </div>
            </div>
            <div v-if="emailSent.readyForBackOffice" :key="'readyForReview'" class="contract-management-edit-email__content">
                <div class="contract-management-edit-email__left">{{ $t('contractManagement.edit.form.complete.review') }}</div>
                <div class="contract-management-edit-email__right">
                    <span v-if="emailSent.readyForReview">{{ $t('contractManagement.edit.form.emailSent') }}: {{ emailSent.readyForReview | moment("DD/MM/Y\, HH:mm") }}</span>
                    <span v-if="!emailSent.readyForReview"><button class="contract-management-edit-email__btn" @click="contractManagementSendEmailReview">{{ $t('contractManagement.edit.form.email.review') }}</button></span>
                </div>
            </div>
        </transition-group>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementEditEmail/ContractManagementEditEmail.vue